// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2NEsD","head":"Table_head__1XFPg","col":"Table_col__wZZve"};